import { JsEnv } from '../../core/models/js_env';
import { reCalculatePrice } from '../../core/views/common/price_util';
import { Item } from '../models/item';
import { ItemJsEnv } from '../models/item_js_env';

export class PriceCalculationAction {
  static init(jsEnv: JsEnv) {
    const env: ItemJsEnv = new Item(jsEnv.PAGE).getModel();
    if (env.priceCal) {
      const totalPriceElements = document.getElementsByClassName(env.priceCal.totalPriceClassName);
      const eachPriceInputElements = document.getElementsByClassName(
        env.priceCal.eachPriceInputClassName
      );
      if (totalPriceElements.length && eachPriceInputElements.length) {
        // 初回合計金額を集計する
        reCalculatePrice(totalPriceElements, eachPriceInputElements);
        Array.from(eachPriceInputElements).forEach((element) => {
          element.addEventListener('click', () => {
            reCalculatePrice(totalPriceElements, eachPriceInputElements);
          });
        });
      }
    }
  }
}
